import { Component, Input, OnInit } from '@angular/core';
import { CalculationResults } from '../backend-response-models/calc-interfaces.helper';
import { PremyopeRiskScoreCategory, GraphDataEthnicity } from '../backend-response-models/calc-enums.helper';
import { ParentParagraphComponent, ParentParagraphType } from '../parent-paragraph/parent-paragraph.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { COMMON_IMPORTS } from '../common-imports';
import { CreditsComponent } from '../credits/credits.component';
import { PopulationComparisonComponent } from '../population-comparison/population-comparison.component';
import { ReportType } from '../shared/shared-enums/shared.enums';
import { StandardProgressionComponent } from '../standard-progression/standard-progression.component';
import { MyopiaTreatmentsComponent } from '../myopia-treatments/myopia-treatments.component';
import { PatientInfoInputComponent } from '../patient-info-input/patient-info-input.component';

@Component({
  selector: 'app-no-calc-dashboard',
  standalone: true,
  imports: [
    ProgressSpinnerModule,
    PopulationComparisonComponent,
    CreditsComponent,
    ParentParagraphComponent,
    ...COMMON_IMPORTS,
    StandardProgressionComponent,
    MyopiaTreatmentsComponent,
    PatientInfoInputComponent,
  ],
  templateUrl: './no-calc-dashboard.component.html',
  styleUrl: './no-calc-dashboard.component.css',
})
export class NoCalcDashboardComponent implements OnInit {
  PremyopeRiskScoreCategory = PremyopeRiskScoreCategory;
  GraphDataEthnicity = GraphDataEthnicity;
  ParentParagraphType = ParentParagraphType;
  ReportType = ReportType;

  hasActiveTreatment = false;

  @Input({ required: true })
  calculationResults!: CalculationResults;

  @Input({ required: true })
  reportType!: ReportType;

  @Input()
  patientName: string = 'Anonymous';

  currentEthnicity: GraphDataEthnicity = GraphDataEthnicity.WESTERN;

  onEthnicityChange(newEthnicity: GraphDataEthnicity): void {
    this.currentEthnicity = newEthnicity;
  }

  ngOnInit(): void {
    this.hasActiveTreatment = this.calculationResults.myopeProgressionResults?.hasActiveTreatment ?? false;
    console.log(`${this.reportType}`);
  }
}
